export interface Address {
  addressLineOne: string | undefined
  addressLineTwo: string | undefined
  city: string | undefined
  country: string | undefined
  zipCode: string | undefined
  lat?: number
  long?: number
}

export interface AddressLookupProps {
  onSelect?: (value: Address) => void
  googleMapsApiKey: string
  language?: string
  placeholder?: string
}
